/**
 * Tiny, side-effect-free E2E flag + nav-bridge ref. Safe to import from app code
 * (SplashScreen, App) WITHOUT pulling in the heavy e2eTestHooks module (which
 * assigns window.__TEST__). e2eTestHooks.ts must remain referenced ONLY by the
 * VITE_E2E-gated dynamic import in main.tsx so it is dead-code-eliminated from
 * every production bundle.
 *
 * Uses Vite's native `import.meta.env.MODE`: build:e2e passes `--mode e2e`, every
 * prod/preview build is `production`. So `window.__TEST__` is never attached in prod.
 */
export const IS_E2E = import.meta.env.MODE === "e2e";

type NavigateFn = (path: string) => void;
let testNavigate: NavigateFn | null = null;

/** Set by <TestNavBridge> so the test hooks can do real SPA navigation. */
export function setTestNavigate(fn: NavigateFn): void {
  testNavigate = fn;
}

export function getTestNavigate(): NavigateFn | null {
  return testNavigate;
}
